module.exports = __webpack_public_path__ + "static/media/teachers-work-for.52617dc0.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/teachers-work-for.png
 ** module id = 518
 ** module chunks = 0
 **/